import { DatePicker as AntDatePicker } from 'antd';
import 'moment/locale/ko';
import locale from 'antd/lib/date-picker/locale/ko_KR';
import moment from 'moment';
import { RangePickerProps as AntRangePickerProps } from 'antd/lib/date-picker';

const { RangePicker } = AntDatePicker;

// 한국어로 변경. 1주일 시작 요일 설정. 1:월요일...7:일요일
moment.locale('ko', {
  week: {
    dow: 7,
  },
});

export type DateRangePickerProps = {
  // TODO
};

const DateRangePicker = (props: DateRangePickerProps & AntRangePickerProps) => {
  const { className } = props;
  const classNames = [className, 'date-range-picker'];
  return <RangePicker {...props} locale={locale} className={classNames.join(' ')} />;
};

DateRangePicker.defaultProps = {
  picker: 'date',
  allowClear: true,
  disabled: false,
};

export default DateRangePicker;
